module.exports = __webpack_public_path__ + "img/savings-mobile.02f882c2.svg";